import { StarIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import {
  SearchResultButton,
  SearchResultList,
} from "@/components/SearchResultList/SearchResultList";
import type { Airport, City } from "@/types/types";

type Props<T> = {
  topLocations: T[];
  onClick: (location: T) => void;
  getPrimaryText?: (location: T) => React.ReactNode;
  showCode?: boolean;
};

export function TopLocationList<T extends Airport | City>({
  onClick,
  topLocations,
  getPrimaryText = (loc) => loc.name,
  showCode,
}: Props<T>) {
  const intl = useIntl();

  return (
    <SearchResultList
      heading={intl.formatMessage({
        id: "topLocations",
        defaultMessage: "Top locations",
      })}
      data={topLocations}
      getItemKey={(location) => location.id}
      renderItem={(location) => {
        return (
          <SearchResultButton
            key={location.id}
            icon={StarIcon}
            primaryText={getPrimaryText(location)}
            secondaryText={location.countryName}
            code={showCode ? location.code : undefined}
            onClick={() => onClick(location)}
          />
        );
      }}
    />
  );
}
